import React, { Component } from "react";

import Header from "./component_modules/Header";
import Main from "./component_modules/Main";

function App() {
  return (
    <React.Fragment>
      <Header></Header>
      <Main></Main>
    </React.Fragment>
  );
}

export default App;
